import React from 'react';
import { Container, Divider, Stack } from '@fiverr-private/layout_components';
import { LogoMakerLayout, Nav, NavIcon, NavItem } from '../../blocks';
import {
    ExploreDropdown,
    GoToFiverrLink,
    JoinButton,
    LogoMakerBackButton,
    LogoMakerLogo,
    MakeYourLogoButton,
    PORTAL_NAME,
    PricingLink,
    SignInLink,
    TestimonialsLink,
    TutorialsLink,
    PortalTarget,
} from '../../components';
import { useLogoMakerContext } from '../../context/LogoMakerContext';

export interface LoggedOutLogoMakerBaseProps {
    showSeoLinks?: boolean;
    showJoinLink?: boolean;
}

export const LoggedOutLogoMakerBase = (props: LoggedOutLogoMakerBaseProps) => {
    const { showSeoLinks, showJoinLink = true } = props;
    const { isSticky, isTransparent } = useLogoMakerContext();

    return (
        <LogoMakerLayout isFullWidth>
            <Stack justifyContent="spaceBetween" alignItems="center" width="100%">
                <Stack direction="row" alignItems="center">
                    <LogoMakerBackButton />
                    <LogoMakerLogo />
                </Stack>
                <PortalTarget name={PORTAL_NAME} className="content-container" />
                <Stack padding="0" gap={{ default: '4', lg: '4' }} alignItems="center">
                    <Nav gap="2" displayFrom="md">
                        {!!showSeoLinks && (
                            <>
                                <NavItem>
                                    <ExploreDropdown />
                                </NavItem>
                                <NavItem>
                                    <TestimonialsLink />
                                </NavItem>
                                <NavItem>
                                    <TutorialsLink />
                                </NavItem>
                                <NavItem>
                                    <PricingLink />
                                </NavItem>
                            </>
                        )}
                        {!showSeoLinks && (
                            <NavItem>
                                <GoToFiverrLink />
                            </NavItem>
                        )}
                    </Nav>
                    <Divider
                        borderColor={isTransparent ? 'white' : 'border'}
                        direction="vertical"
                        height="24px"
                        hidden={{ default: true, md: false }}
                    />
                    <Nav gap="2" displayFrom="md">
                        <NavItem>
                            <SignInLink />
                        </NavItem>
                        {showJoinLink && !isSticky && (
                            <NavItem>
                                <JoinButton />
                            </NavItem>
                        )}
                        {isSticky && (
                            <NavItem>
                                <MakeYourLogoButton />
                            </NavItem>
                        )}
                    </Nav>
                </Stack>
                <Container
                    hidden={{
                        default: false,
                        md: true,
                    }}
                >
                    <NavIcon />
                </Container>
            </Stack>
        </LogoMakerLayout>
    );
};
